import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import calendarData from '../../utils/formatCalendarEvents';
import formatNewCalendarEvents from '../../utils/formatNewCalendarEvents';

const initialState = {
    calendarEvents: [],
    before: '',
    after: '',
    loading: false,
    loadingModal: false,
    loadingMoreModal: false,
    totalEventsCount: 0,
    modalOpen: false,
    modalData: [],
    modalType: '',
    modalDate: new Date(),
    modalStage: '',
    modalTitle: '',
    calendarDate: new Date(),
    // Filters
    filteredUsers: [],
    filteredEquipmentModels: [],
    filteredEquipmentGroups: [],
    filteredPlaces: [],
    filteredModules: ['actions', 'services', 'servicesReplicated', 'maintenances'],
    filteredServiceTypes: [],
    filteredFrequencies: [],
    filteredAreas: [],
    filteredCompanies: [],
    filteredStatus: [],
    filteredStatusMaintenances: [],
    filteredUsersMaintenances: [],
    loadingPdfExport: false,
};

// types: DoneServices, OverdueServices, ScheduledService
// DoneAction, OverdueAction, ScheduledAction

// stage: Done, Overdue, Scheduled
// type: Service, Action


const requestCalendarsStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchCalendarsSuccess = (state, action) => {
    const calendarEvents = formatNewCalendarEvents(action.calendarEvents);
    return updateObject( state, {
        calendarEvents: calendarEvents,
        before: action.before,
        after: action.after,
        loading: false
    } );
};

const requestCalendarsFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const modalCalendarsOpen = ( state, action ) => {
  return updateObject( state, {modalOpen: true, modalType: action.modalType, modalDate: action.date, modalStage: action.stage, modalTitle: action.title } );
};

const modalCalendarsClose = (state) => {
  return updateObject( state, { modalOpen: false, modalType: '', modalDate: new Date(), modalStage: '', modalTitle: '', modalData: [], totalEventsCount: 0} );
};

const setCalendarsDate = ( state, action ) => {
  return updateObject( state, { calendarDate: action.date} );
};

const clearCalendarsState = ( state, action ) => {
  return updateObject( state,   { modalOpen: false,
    modalData: [],
    calendarDate: new Date()}
  );
};

const filterCalendarUsers = (state, action) => {
  return updateObject(state, { filteredUsers: action.users });
}

const filterCalendarUsersRemove = (state, action) => {
	let arr = [...state.filteredUsers];
	const filteredUsers = arr.filter(user => user.value !== action.user.value)
  return updateObject(state, { filteredUsers });
}

const filterCalendarUsersMaintenances = (state, action) => {
  return updateObject(state, { filteredUsersMaintenances: action.users });
}

const filterCalendarUsersMaintenancesRemove = (state, action) => {
	let arr = [...state.filteredUsersMaintenances];
	const filteredUsersMaintenances = arr.filter(user => user.value !== action.user.value)
  return updateObject(state, { filteredUsersMaintenances });
}

const filterCalendarEquipmentGroups = (state, action) => {
  return updateObject(state, { filteredEquipmentGroups: action.equipmentGroups });
}

const filterCalendarEquipmentGroupsRemove = (state, action) => {
	let arr = [...state.filteredEquipmentGroups];
	const filteredEquipmentGroups = arr.filter(equipment => equipment.value !== action.equipmentGroup.value)
  return updateObject(state, { filteredEquipmentGroups });
}

const filterCalendarPlaces = (state, action) => {
  return updateObject(state, { filteredPlaces: action.places });
}

const filterCalendarPlacesRemove = (state, action) => {
	let arr = [...state.filteredPlaces];
	const filteredPlaces = arr.filter(equipment => equipment.value !== action.place.value)
  return updateObject(state, { filteredPlaces });
}

const filterCalendarEquipmentModels = (state, action) => {
  return updateObject(state, { filteredEquipmentModels: action.equipmentModels });
}

const filterCalendarEquipmentModelsRemove = (state, action) => {
	let arr = [...state.filteredEquipmentModels];
	const filteredEquipmentModels = arr.filter(equipment => equipment.value !== action.equipmentModel.value)
  return updateObject(state, { filteredEquipmentModels });
}

const filterCalendarModules = (state, action) => {
  return updateObject(state, { filteredModules: action.modules });
}

const filterCalendarModulesRemove = (state, action) => {
	let arr = [...state.filteredModules];
	const filteredModules = arr.filter(module => module !== action.module)
  return updateObject(state, { filteredModules });
}

const filterCalendarAreas = (state, action) => {
  return updateObject(state, { filteredAreas: action.areas });
}

const filterCalendarAreasRemove = (state, action) => {
	let arr = [...state.filteredAreas];
	const filteredAreas = arr.filter(area => area.value !== action.area.value)
  return updateObject(state, { filteredAreas });
}

const filterCalendarStatus = (state, action) => {
  return updateObject(state, { filteredStatus: action.status });
}

const filterCalendarStatusRemove = (state, action) => {
	let arr = [...state.filteredStatus];
  const filteredStatus = arr.filter(status => status.value !== action.status.value)
  return updateObject(state, { filteredStatus });
}

const filterCalendarStatusMaintenances = (state, action) => {
  return updateObject(state, { filteredStatusMaintenances: action.status });
}

const filterCalendarStatusMaintenancesRemove = (state, action) => {
	let arr = [...state.filteredStatusMaintenances];
  const filteredStatusMaintenances = arr.filter(status => status.value !== action.status.value)
  return updateObject(state, { filteredStatusMaintenances });
}

const filterCalendarCompanies = (state, action) => {
  return updateObject(state, { filteredCompanies: action.companies });
}

const filterCalendarCompaniesRemove = (state, action) => {
  let arr = [...state.filteredCompanies];
	const filteredCompanies = arr.filter(company => company.value !== action.company.value)
  return updateObject(state, { filteredCompanies });
}

const filterCalendarClear = (state, action) => {
  return updateObject(state, { filteredUsers: [], filteredUsersMaintenances: [], filteredEquipmentModels: [], filteredEquipmentGroups: [], filteredModules: [], filteredServiceTypes: [], filteredFrequencies: [], filteredAreas: [], filteredCompanies: [], filteredPlaces: [], filteredStatus: [], filteredStatusMaintenances: [] });
}

const filterCalendarServiceTypes = (state, action) => {
  return updateObject(state, { filteredServiceTypes: action.serviceTypes });
}

const filterCalendarServiceTypesRemove = (state, action) => {
	let arr = [...state.filteredServiceTypes];
	const filteredServiceTypes = arr.filter(serviceType => serviceType.value !== action.serviceType.value)
  return updateObject(state, { filteredServiceTypes });
}

const filterCalendarFrequencies = (state, action) => {
  return updateObject(state, { filteredFrequencies: action.frequencies });
}

const filterCalendarFrequenciesRemove = (state, action) => {
	let arr = [...state.filteredFrequencies];
	const filteredFrequencies = arr.filter(frequency => frequency.value !== action.frequency.value)
  return updateObject(state, { filteredFrequencies });
}

const startModalFetch = (state, action) => {
  if (action.isNew) return updateObject(state, { loadingModal: true });
  return updateObject(state, { loadingMoreModal: true });
}

const fetchModalDataSuccess = (state, action) => {
  const { data, count } = action.payload;
  return updateObject(state, { modalData: data, loadingModal: false, totalEventsCount: count });
}

const fetchMoreModalDataSuccess = (state, action) => {
  const { data, count } = action.payload;
  const modalData = [...state.modalData, ...data];
  return updateObject(state, { modalData, loadingMoreModal: false });
}

const fetchModalDataFail = (state) => {
  return updateObject(state, { loadingModal: false, loadingMoreModal: false });
}

const fetchPdfExportStart = (state) => {
  return updateObject(state, { loadingPdfExport: true });
}

const fetchPdfExportSuccessFail = (state) => {
  return updateObject(state, { loadingPdfExport: false });
}


const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.REQUEST_CALENDARS_START: return requestCalendarsStart( state, action );
        case actionTypes.FETCH_CALENDARS_SUCCESS: return fetchCalendarsSuccess( state, action );
        case actionTypes.REQUEST_CALENDARS_FAIL: return requestCalendarsFail( state, action );

        case actionTypes.MODAL_CALENDARS_OPEN: return modalCalendarsOpen( state, action );
        case actionTypes.MODAL_CALENDARS_CLOSE: return modalCalendarsClose(state);
        case actionTypes.SET_CALENDARS_DATE: return setCalendarsDate( state, action );
        case actionTypes.CLEAR_CALENDARS_STATE: return clearCalendarsState( state, action );
        // filter
        case actionTypes.FILTER_CALENDAR_USERS: return filterCalendarUsers( state, action );
        case actionTypes.FILTER_CALENDAR_USERS_REMOVE: return filterCalendarUsersRemove( state, action );
        case actionTypes.FILTER_CALENDAR_MODELS: return filterCalendarEquipmentModels( state, action );
        case actionTypes.FILTER_CALENDAR_MODELS_REMOVE: return filterCalendarEquipmentModelsRemove( state, action );
        case actionTypes.FILTER_CALENDAR_GROUPS: return filterCalendarEquipmentGroups( state, action );
        case actionTypes.FILTER_CALENDAR_GROUPS_REMOVE: return filterCalendarEquipmentGroupsRemove( state, action );
        case actionTypes.FILTER_CALENDAR_PLACES: return filterCalendarPlaces( state, action );
        case actionTypes.FILTER_CALENDAR_PLACES_REMOVE: return filterCalendarPlacesRemove( state, action );
        case actionTypes.FILTER_CALENDAR_MODULES: return filterCalendarModules( state, action );
        case actionTypes.FILTER_CALENDAR_MODULES_REMOVE: return filterCalendarModulesRemove( state, action );
        case actionTypes.FILTER_CALENDAR_CLEAR: return filterCalendarClear( state, action );
        case actionTypes.FILTER_CALENDAR_SERVICE_TYPES: return filterCalendarServiceTypes(state, action);
        case actionTypes.FILTER_CALENDAR_SERVICE_TYPES_REMOVE: return filterCalendarServiceTypesRemove(state, action);
        case actionTypes.FILTER_CALENDAR_FREQUENCIES: return filterCalendarFrequencies(state, action);
        case actionTypes.FILTER_CALENDAR_FREQUENCIES_REMOVE: return filterCalendarFrequenciesRemove(state, action);
        case actionTypes.FILTER_CALENDAR_AREAS: return filterCalendarAreas( state, action );
        case actionTypes.FILTER_CALENDAR_AREAS_REMOVE: return filterCalendarAreasRemove( state, action );
        case actionTypes.FILTER_CALENDAR_COMPANIES: return filterCalendarCompanies( state, action );
        case actionTypes.FILTER_CALENDAR_COMPANIES_REMOVE: return filterCalendarCompaniesRemove( state, action );
        case actionTypes.FILTER_CALENDAR_STATUS: return filterCalendarStatus( state, action );
        case actionTypes.FILTER_CALENDAR_STATUS_REMOVE: return filterCalendarStatusRemove( state, action );
        case actionTypes.FILTER_CALENDAR_STATUS_MAINTENANCES: return filterCalendarStatusMaintenances( state, action );
        case actionTypes.FILTER_CALENDAR_STATUS_MAINTENANCES_REMOVE: return filterCalendarStatusMaintenancesRemove( state, action );
        case actionTypes.FILTER_CALENDAR_USERS_MAINTENANCES: return filterCalendarUsersMaintenances( state, action );
        case actionTypes.FILTER_CALENDAR_USERS_MAINTENANCES_REMOVE: return filterCalendarUsersMaintenancesRemove( state, action );
        // modal
        case actionTypes.CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_START: return startModalFetch(state, action);
        case actionTypes.CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_SUCCESS: return fetchModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_MORE_COMPLETED_ACTIONS_BYDAY_SUCCESS: return fetchMoreModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_FAIL: return fetchModalDataFail(state);
        case actionTypes.CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_START: return startModalFetch(state, action);
        case actionTypes.CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_SUCCESS: return fetchModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_MORE_INPROGRESS_ACTIONS_BYDAY_SUCCESS: return fetchMoreModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_FAIL: return fetchModalDataFail(state);
        case actionTypes.CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_START: return startModalFetch(state, action);
        case actionTypes.CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_SUCCESS: return fetchModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_MORE_COMPLETED_SERVICES_BYDAY_SUCCESS: return fetchMoreModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_FAIL: return fetchModalDataFail(state);
        case actionTypes.CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_START: return startModalFetch(state, action);
        case actionTypes.CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_SUCCESS: return fetchModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_MORE_INPROGRESS_SERVICES_BYDAY_SUCCESS: return fetchMoreModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_FAIL: return fetchModalDataFail(state);
        case actionTypes.CALENDAR_FETCH_MAINTENANCES_BYDAY_START: return startModalFetch(state, action);
        case actionTypes.CALENDAR_FETCH_MAINTENANCES_BYDAY_SUCCESS: return fetchModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_MORE_MAINTENANCES_BYDAY_SUCCESS: return fetchMoreModalDataSuccess(state, action);
        case actionTypes.CALENDAR_FETCH_MAINTENANCES_BYDAY_FAIL: return fetchModalDataFail(state);
        case actionTypes.CALENDAR_FETCH_PDF_REPORT_START: return fetchPdfExportStart(state);
        case actionTypes.CALENDAR_FETCH_PDF_REPORT_SUCCESS: return fetchPdfExportSuccessFail(state);
        case actionTypes.CALENDAR_FETCH_PDF_REPORT_FAIL: return fetchPdfExportSuccessFail(state);


        default: return state;
    }
};

export default reducer;
